var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountOwner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 95.6 93.8",
    style: {
      enableBackground: "new 0 0 95.6 93.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#0B2967;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st1{fill:#0B2967;stroke:#0B2967;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st2{fill:none;stroke:#0B2967;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000037655880296331208510000013842359228484934019_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000097491150539245298360000004177367370263276206_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.6,67.2v21.5c0,2.2-1.8,4-4,4c0,0,0,0,0,0H53.1c-2.2,0-4-1.8-4-4c0,0,0,0,0,0V67.2c0-2.2,1.8-4,4-4 c0,0,0,0,0,0h37.5C92.8,63.2,94.6,65,94.6,67.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.1,
    y: 69.7,
    className: "st1",
    width: 45.5,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.6,
    y: 83.8,
    className: "st1",
    width: 8.7,
    height: 3.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 53.9,
    y1: 83.8,
    x2: 67.4,
    y2: 83.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 53.9,
    y1: 87.7,
    x2: 61.9,
    y2: 87.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42,1.2c-10,0-18.2,8.7-18.2,19.3c0,10.7,8.2,19.3,18.2,19.3s18.2-8.7,18.2-19.3C60.2,9.8,52.2,1.2,42,1.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.5,60l-0.4-3c-0.1-1-0.8-1.9-1.8-2.3L63,49.8c-0.3-0.1-0.5-0.2-0.7-0.5l-8.2-8.1l-12,8.3 c-0.7,0.5-1.6,0.5-2.2,0L27.5,41l-10.2,7.7C17.1,49,17,49,16.9,49L6.1,54.2c-0.8,0.4-1.4,1.2-1.5,2.1L1.2,76.4h44.4"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountOwner);
export default __webpack_public_path__ + "static/media/account_owner.184c8a462f456a2c6109101b430effdc.svg";
export { ForwardRef as ReactComponent };